import React from "react";
import language from "../../localization";
import styles from "./style.module.css";

export const SEARCH_TYPES = ["all", "program", "conference", "seminar", "meeting", "committee"];

export const getSearchTypeLabel = (type) => {
  const labels = {
    all: language.search_all,
    program: language.master_programs,
    conference: language.search_conferences,
    seminar: language.search_seminars,
    meeting: language.search_meetings,
    committee: language.search_committees,
  };

  return labels[type] || labels.all;
};

function SearchFilters({ activeType = "all", onChange, compact = false }) {
  return (
    <div className={[styles.filters, compact ? styles.compactFilters : ""].join(" ")} role="tablist" aria-label={language.search_filter_label}>
      {SEARCH_TYPES.map((type) => (
        <button
          type="button"
          role="tab"
          aria-selected={activeType === type}
          key={type}
          className={[styles.filterButton, activeType === type ? styles.activeFilter : ""].join(" ")}
          onClick={() => onChange(type)}
        >
          {getSearchTypeLabel(type)}
        </button>
      ))}
    </div>
  );
}

export default SearchFilters;
